export default {
  selected: 'Selezionato',
  deselect_all_selected_options: 'Deseleziona tutte le opzioni selezionate',
  expanded: 'Espanso',
  collect: 'Raccogliere',
  no_options_available: 'Nessuna opzione disponibile',
  required: 'Obbligatorio',
  input_clear_aria_label: 'Cancella input',
  input_show_hide_password_aria_label: 'Mostra o nascondi password',
  input_increment_aria_label: 'Aumenta valore',
  input_decrement_aria_label: 'Diminuisci valore',
  english: 'Inglese',
  chinese: 'Cinese',
  portuguese: 'Portoghese',
  spanish: 'Spagnolo',
  dutch: 'Olandese',
  french: 'Francese',
  german: 'Tedesco',
  russian: 'Russo',
  ukrainian: 'Ucraino',
  korean: 'Coreano',
  italian: 'Italiano',
  czech: 'Ceco',
  access_your_account: 'Accedi al tuo account',
  use_your_company_credentials_to_get_started:
    'Utilizza le credenziali aziendali per iniziare',
  internal_user_login: 'Utente Interno (SSO)',
  external_user_login: 'Utente Esterno',
  or: 'o',
  keycloak_init_error:
    'Impossibile connettersi al server di autenticazione. Controllare la connessione di rete e riprovare.',
  this_link_has_expired: 'Questo link è scaduto',
  login: 'Accedi',
  sample_no_production_date_message:
    'È obbligatorio selezionare una data di produzione.',
  free_comment: 'Commento libero',
  save_comments: 'Salva & Chiudi',
  round_list_rounds: 'Turni',
  round_edit_round: 'Modifica Turno',
  round_new_round: 'Nuovo Turno',
  round_remove_round: 'Sei sicuro di voler eliminare il turno?',
  round_schedule: 'Pianificazione',
  round_tasters_unselect_all: 'Deseleziona tutti i degustatori',
  round_tasters_select_all: 'Seleziona tutti i degustatori',
  round_close: 'Chiudi Turno',
  round_close_message: 'Sei sicuro di voler terminare questo turno?',
  round_create_site_message: 'Stai creando un turno che non è del tuo sito!',
  round_closed_message: 'I turni chiusi non possono essere modificati',
  round_status_created: 'Creato',
  round_status_samples: 'Campioni',
  round_status_scheduled: 'Pianificato',
  round_status_tasters: 'Degustatori',
  round_status_in_progress: 'In corso',
  round_status_finished: 'Terminato',
  round_status_closed: 'Chiuso',
  round_schedule_start_finish_date:
    'La data di inizio non può essere successiva alla data di fine!',
  round_schedule_finish_date_no_start_date:
    'Devi prima selezionare una data di inizio!',
  round_disabled_discussion_tooltip:
    'Non puoi accedere a una Discussione di un turno non terminato.',
  round_up_down_maintenance_tooltip:
    'Questa funzionalità è in manutenzione e temporaneamente non disponibile',
  round_delete_other_users_rounds:
    'Non sei autorizzato a eliminare un turno che non hai creato',
  round_randomize_samples_order_button: 'Mescola',
  round_block_results_tooltip:
    'Blocca i risultati di questo turno per impedirne il download nella schermata report. Se il pulsante è disabilitato, non hai il privilegio di bloccare i risultati dei turni da questa posizione.',
  round_block_results_confirm:
    'Sei sicuro di voler bloccare/sbloccare i risultati del turno?',
  round_block_results_no_privilege:
    'Non hai il privilegio di bloccare/sbloccare i risultati dei turni da questa posizione.',
  sample_list_samples: 'Campioni',
  sample_edit_sample: 'Modifica campione',
  sample_new_sample: 'Nuovo campione',
  sample_remove_sample: 'Rimuovi campione',
  sample_upload_document: 'Carica documenti',
  sample_download_documents: 'Documenti campione',
  sample_tasted_dates: 'Data degustazione',
  sample_upload_message:
    'Per caricare documenti multipli, aggiungili in un file .zip',
  sample_not_for_kpi: 'Non per KPI',
  sample_package: 'Confezionamento',
  sample_volume: 'Volume',
  sample_production_date: 'Data di produzione',
  sample_expire_date: 'Data di scadenza',
  sample_trial_identifier: 'Identificativo prova',
  sample_project_name: 'Nome progetto',
  sample_linked: 'Collegato a un turno',
  sample_expire_bigger_than_production:
    'La data di produzione non può essere successiva alla data di scadenza!',
  sample_no_site_message:
    'È obbligatorio selezionare Zona, Paese e Sito per creare un campione.',
  sample_no_brand_message: 'È obbligatorio selezionare una Marca.',
  sample_duplicated_kpi_message:
    'Esiste già un KPI per il mese, la marca e il sito che hai selezionato e non potrai salvare.',
  sample_duplicated_kpi_message_quarter:
    'Esiste già un KPI per il trimestre, la marca e il sito selezionati e non potrai salvare.',
  sample_duplicated_project_message:
    'Esiste già un campione con questo nome progetto e identificativo prova per questo sito e marca e non potrai salvare.',
  sample_project_no_name_or_trial:
    'Nome progetto e Identificativo prova sono obbligatori quando si crea un campione tipo Progetto.',
  sample_production_to_project_confirm_message:
    'Stai cambiando il tipo di questo campione da PRODUZIONE a PROGETTO. Vuoi continuare?',
  sample_project_to_production_confirm_message:
    'Stai cambiando il tipo di questo campione da PROGETTO a PRODUZIONE. Vuoi continuare?',
  sample_no_volume_message:
    'Confezionamento e Volume sono obbligatori quando si crea/modifica un campione.',
  sample_id_code_message: 'Includi il numero di lotto completo.',
  sample_show_all_samples_hint:
    'Vengono mostrati i campioni creati fino a un anno fa. Seleziona questa casella se vuoi vedere anche campioni più vecchi.',
  sample_show_all_samples_label: 'Mostra tutti i campioni',
  package_duplicate: 'Esiste già un confezionamento con questo nome',
  common_production: 'Produzione',
  day: 'giorno',
  common_project: 'Progetto',
  group_list_groups: 'Gruppi',
  group_edit_group: 'Modifica gruppo',
  group_new_group: 'Nuovo gruppo',
  group_remove_group: 'Rimuovi gruppo',
  group_close_modal: 'Chiudi',
  group_duplicated_user: 'Questo utente è già stato aggiunto a questo gruppo!',
  group_no_name_message: 'È necessario inserire un nome gruppo.',
  group_no_zone_message: 'È necessario selezionare una zona.',
  group_no_users_message: 'È necessario selezionare almeno un degustatore.',
  family_list_families: 'Stili',
  family_edit_family: 'Modifica stile',
  family_new_family: 'Nuovo stile',
  family_remove_family: 'Rimuovi stile',
  families_page_description:
    'Gestisci tutti gli stili e le relative configurazioni in un unico posto',
  family_new_page_description:
    'Compila le informazioni dello stile e completa la creazione.',
  family_edit_page_description: 'Modifica le informazioni dello stile.',
  family_save_success: 'Stile creato con successo!',
  family_update_success: 'Stile aggiornato con successo!',
  family_save_failed: 'Salvataggio dello stile non riuscito.',
  family_save_success_desc: 'Controlla negli stili qui sotto.',
  family_update_success_desc: 'Controlla negli stili qui sotto.',
  family_save_failed_desc: 'Riprova tra un momento.',
  the_name_is_duplicated: 'Il nome è duplicato.',
  common_style_name: 'Nome Stile',
  common_warning: 'Avviso',
  cancel_new_family_title: 'Annulla nuovo stile?',
  cancel_edit_family_title: 'Annulla modifica stile?',
  cancel_new_family_confirm: 'Annulla nuovo stile',
  cancel_edit_family_confirm: 'Annulla modifica stile',
  family_remove_success: 'Stile rimosso con successo',
  family_remove_failed: 'Impossibile rimuovere lo stile',
  family_delete_title: 'Eliminare stile?',
  family_delete_description:
    'Lo stile {{name}} verrà rimosso definitivamente. Sei sicuro di voler continuare?',
  family_delete_success: 'Stile eliminato con successo!',
  family_delete_success_desc: 'Lo stile è stato rimosso.',
  family_delete_failed: 'Eliminazione dello stile non riuscita.',
  family_delete_failed_desc: 'Riprova tra un momento.',
  family_has_no_english_name:
    'È obbligatorio avere il nome dello stile in inglese.',
  brand_list_brands: 'Marche',
  brand_edit_brand: 'Modifica Marca',
  brand_new_brand: 'Nuova Marca',
  brand_remove_brand: 'Rimuovi Marca',
  brand_profile_picture: 'Carica Foto Profilo Birra',
  brand_upload_brand_logo: 'Carica Logo Marca',
  brand_duplicate: 'Attenzione: esiste già una birra con questo nome',
  brand_has_no_english_name:
    'È necessario avere almeno un nome Marca e un profilo Marca corrispondente.',
  brand_upload_help_message: 'Solo file PNG e JPG',
  brand_has_no_product_type: 'Devi selezionare un tipo prodotto.',
  package_list_packages: 'Confezionamenti',
  package_edit_package: 'Modifica Confezionamento',
  package_new_package: 'Nuovo Confezionamento',
  package_remove_package: 'Rimuovi Confezionamento',
  packages_page_description:
    'Gestisci tutti i tipi di confezionamento e le relative configurazioni in un unico luogo.',
  comments_page_description:
    'Gestisci tutti gli attributi e le relative configurazioni in un unico luogo.',
  comments_new_page_description:
    "Compila le informazioni dell'attributo e completa la creazione.",
  comments_edit_page_description:
    "Modifica le informazioni dell'attributo e completa l'aggiornamento.",
  comment_attribute_name: "Nome dell'attributo di aroma",
  comment_select_category: 'Seleziona Categoria Aroma',
  packages_edit_page_description:
    "Modifica le informazioni del confezionamento e completa l'aggiornamento.",
  package_successfully_created: 'Confezionamento creato con successo!',
  package_successfully_created_desc:
    'Controllalo nei confezionamenti seguenti.',
  package_successfully_updated: 'Confezionamento aggiornato con successo!',
  package_successfully_updated_desc:
    'Controllalo nei confezionamenti seguenti.',
  packages_new_page_description:
    'Compila le informazioni del confezionamento e completa la creazione.',
  package_name: 'Nome del confezionamento',
  content_already_exists: 'Il contenuto esiste già.',
  language_english: 'Inglese',
  language_chinese: 'Cinese',
  language_portuguese: 'Portoghese',
  language_spanish: 'Spagnolo',
  language_dutch: 'Olandese',
  language_french: 'Francese',
  language_german: 'Tedesco',
  language_russian: 'Russo',
  language_ukrainian: 'Ucraino',
  language_korean: 'Coreano',
  language_italian: 'Italiano',
  package_has_no_english_name:
    'È obbligatorio avere il nome del Confezionamento in inglese.',
  package_volumes: 'Volumi',
  package_new_volume: 'Nuovo Volume',
  package_remove_volume: 'Rimuovi Volume',
  degree_list_degrees: 'Intensità',
  degree_edit_degree: 'Modifica Intensità',
  degree_new_degree: 'Nuova Intensità',
  degree_remove_degree: 'Rimuovi Intensità',
  category_list_categories: 'Categorie',
  category_edit_category: 'Modifica Categoria Aroma',
  category_new_category: 'Nuova Categoria Aroma',
  category_remove_category: 'Rimuovi Categoria Aroma',
  comment_list_comments: 'Attributi',
  comment_edit_comment: 'Modifica Attributo Aroma',
  comment_new_comment: 'Nuovo Attributo Aroma',
  comment_remove_comment: 'Rimuovi Attributo Aroma',
  comment_cancel_new_title: 'Annullare il nuovo attributo di aroma?',
  comment_cancel_edit_title: "Annullare la modifica dell'attributo di aroma?",
  comment_cancel_new_confirm: 'Annullare il nuovo attributo di aroma',
  comment_cancel_edit_confirm: "Annullare la modifica dell'attributo di aroma",
  comment_successfully_created: 'Attributo di aroma creato con successo!',
  comment_successfully_created_desc: "Controllalo nell'attributo qui sotto.",
  comment_successfully_updated: 'Attributo di aroma aggiornato con successo!',
  comment_successfully_updated_desc: "Controllalo nell'attributo qui sotto.",
  comment_create_failed: "Impossibile creare l'attributo di aroma.",
  comment_update_failed: "Impossibile aggiornare l'attributo di aroma.",
  comment_failed_desc: 'Riprova tra un momento.',
  comment_delete_title: 'Eliminare attributo?',
  comment_delete_description:
    "L'attributo {{name}} verrà rimosso definitivamente. Sei sicuro di voler continuare?",
  comment_delete_success: 'Attributo eliminato con successo!',
  comment_delete_success_desc: "Controllalo nell'attributo qui sotto.",
  comment_delete_failed: "Impossibile eliminare l'attributo.",
  comment_delete_failed_desc: 'Riprova tra un momento.',
  user_list_users: 'Utenti',
  user_edit_user: 'Modifica Utente',
  user_new_user: 'Nuovo utente ABI',
  user_export_users: 'Esporta Utenti',
  user_list_profiles: 'Profili',
  user_profile_name: 'Nome Profilo',
  user_profile_select: 'Seleziona un Profilo',
  user_profile_remove: 'Rimuovi Profilo',
  user_profile_save: 'Salva Profilo',
  user_remove_user: 'Rimuovi Utente',
  user_use_terms: 'Termini di utilizzo accettati',
  report_list_report: 'Report',
  report_start_date: 'Data inizio',
  report_end_date: 'Data fine',
  common_privileges: 'Privilegi',
  common_abi_name: 'Nome ABI',
  common_id: 'ID',
  common_ranked: 'Classificato',
  common_week: 'Settimana',
  common_weeks: 'Settimane',
  common_days: 'Giorni',
  common_category: 'Categoria Aroma',
  common_category_sample: 'Categoria',
  common_degree: 'Intensità',
  common_comment: 'Attributo Aroma',
  common_status: 'Stato',
  common_zone: 'Zona',
  common_country: 'Paese',
  common_site: 'Sito',
  common_start_date: 'Data inizio',
  common_finish_date: 'Data fine',
  common_round_type: 'Tipo Test',
  common_type: 'Tipo',
  common_round: 'Turno',
  common_round_id: 'ID Turno',
  common_tasters: 'Degustatori',
  common_taster: 'Degustatore',
  common_sample_performance: 'Performance campione',
  common_taste: 'Gusto',
  common_key_taster: 'Degustatore principale',
  common_sample: 'Campione',
  common_samples: 'Campioni',
  common_sample_type: 'Tipo Campione',
  common_family: 'Stile',
  common_brand: 'Marca',
  common_product_type: 'Tipo prodotto',
  common_temperature: 'Condizioni conservazione',
  common_storage_times: 'Tempo conservazione',
  common_sku: 'SKU',
  common_batch: 'Codice ID',
  common_kpi_month: 'Mese KPI',
  common_logo: 'Logo',
  common_name: 'Nome',
  common_notes: 'Note',
  common_email: 'E-mail',
  common_language: 'Lingua',
  common_terms_of_use: "Termini d'uso",
  common_new: 'Nuovo',
  common_profile: 'Profilo',
  common_filter: 'Filtra Utenti',
  common_download: 'Scarica',
  download: 'Scarica',
  common_save: 'Salva',
  common_cancel: 'Annulla',
  cancel_add_taster_title: 'Annullare l’aggiunta del degustatore?',
  cancel_add_taster_description:
    'Hai già selezionato dei degustatori. Annullando perderai la selezione. Vuoi continuare?',
  cancel_add_taster_confirm: 'Annulla aggiunta degustatore',
  cancel_enter_concentration_title: 'Annullare l’inserimento della concentrazione?',
  cancel_enter_concentration_description:
    'Hai inserito un valore di concentrazione. Annullando perderai il dato non salvato. Vuoi continuare?',
  cancel_enter_concentration_confirm: 'Annulla inserimento concentrazione',
  cancel_new_package_title: 'Annullare nuovo confezionamento?',
  cancel_edit_package_title: 'Annullare modifica del confezionamento?',
  cancel_new_package_confirm: 'Annulla nuovo confezionamento',
  cancel_edit_package_confirm: 'Annulla modifica del confezionamento',
  common_search_users: 'Cerca Utenti',
  common_search_group: 'Cerca Gruppo',
  common_search_taster: 'Cerca Degustatore',
  common_no_data: 'Nessun dato da visualizzare',
  common_edit: 'Modifica',
  no_results_found_for_applied_filters:
    'Nessun risultato trovato per i filtri applicati',
  common_loading: 'Caricamento...',
  common_search: 'Cerca...',
  type_more_characters: 'Digita altri {{count}} carattere/i...',
  common_cannot_be_empty: '{{field}} non può essere vuoto',
  common_select_option: 'Seleziona opzione...',
  search_placeholder: 'Cerca...',
  no_search_results: 'Nessun risultato trovato',
  clear_selection: 'Cancella selezione',
  common_per_page: 'Righe per pagina',
  common_attributes: 'Attributi',
  common_not_started: 'Non iniziato',
  common_in_progress: 'In corso',
  common_finished: 'Terminato',
  common_start: 'Inizio',
  common_detail: 'Vedi dettagli',
  common_delete: 'Elimina',
  common_position: 'Posizione',
  common_average_key_score: 'Media punteggio chiave',
  common_score: 'Punteggio',
  common_score_scale: 'Scala punteggio',
  common_intensity: 'Intensità',
  common_report_not_have_data: 'I turni selezionati non hanno voti',
  month_0: 'Gennaio',
  month_1: 'Febbraio',
  month_2: 'Marzo',
  month_3: 'Aprile',
  month_4: 'Maggio',
  month_5: 'Giugno',
  month_6: 'Luglio',
  month_7: 'Agosto',
  month_8: 'Settembre',
  month_9: 'Ottobre',
  month_10: 'Novembre',
  month_11: 'Dicembre',
  dropdown_change_picture: 'Cambia Immagine',
  dropdown_language: 'Lingua',
  dropdown_logout: 'Esci',
  logout_title: 'Disconnessione in corso, attendere…',
  logout_description: 'Stai uscendo dal tuo account.',
  round_not_started: 'Non iniziato',
  round_in_progress: 'In corso',
  round_finished: 'Terminato',
  round_filter_start: 'Inizio',
  tasting_list_rounds: 'Elenco Turni',
  menu_tasting_session: 'Sessione Degustazione',
  menu_panel_management: 'Gestione Pannelli',
  menu_process_management: 'Gestione Processi',
  menu_product_management: 'Gestione Prodotti',
  menu_attributes_management: 'Gestione Attributi',
  tasting_finish_sample: 'Finalizza Campione',
  tasting_comments: 'Commenti',
  tasting_beer_profile: 'Profilo Birra',
  tasting_need_select_score_comments:
    'Devi impostare un punteggio e aggiungere almeno un commento per continuare...',
  tasting_finish_taste: 'Termina Degustazione',
  tasting_finish_tasting: 'Termina Degustazione',
  common_no_comments: 'Nessun commento',
  previous_comments: 'Commenti precedenti',
  review_submit_title: 'Sei pronto ad inviare i tuoi risultati?',
  review_submit_description: 'Non potrai più modificare in seguito',
  review_finish_taste: 'Fine Degustazione',
  review_warning_sample_title: 'Hai campioni non degustati!',
  review_warning_sample_description: 'Vuoi continuare senza assaggiarli?',
  review_warning_sample_review: 'Verifica',
  review_warning_sample_ok: 'Continua',
  review_warning_preference_description:
    'Seleziona una preferenza prima di procedere.',
  review_warning_tie_sample_title: 'Hai campioni a parità!',
  review_warning_tie_sample_description:
    'Non puoi continuare senza classificarli!',
  review_warning_tie_sample_review: 'Verifica',
  common_submit: 'Invia',
  common_discussion: 'Discussione',
  common_not_informed: 'Non informato',
  discussion_order_number: 'Ordina per Posizione',
  discussion_order_brewery: 'Ordina per Birrificio',
  discussion_order_ranking: 'Ordina per Classifica',
  discussion_order_brand: 'Ordina per Marca',
  discussion_order_score: 'Ordina per Punteggio',
  discussion_order_key_score: 'Ordina per Punteggio Chiave',
  discussion_order_overall_rank: 'Ordina per Classifica Generale',
  discussion_order_key_rank: 'Ordina per Classifica Chiave',
  discussion_export_error: 'Il file non può essere salvato!',
  discussion_ranking: 'Classifica',
  discussion_overall_ranking: 'Classifica Generale',
  discussion_key_ranking: 'Classifica Chiave',
  common_brewery: 'Birrificio',
  common_trial_identifier: 'ID Prova',
  common_key_score: 'Punteggio Chiave',
  round_report: 'Esporta in Excel',
  common_comments: 'Commenti',
  message_you_cannot_delete_all_comments:
    'Non puoi eliminare tutti i commenti durante la modifica di un voto.',
  common_message_empty_profile:
    'Il nome profilo non può essere vuoto o in bianco.',
  common_message_out_score_range: 'Punteggio fuori scala',
  tasting_need_select_score: 'Devi prima impostare un punteggio!',
  common_category_name: 'Categoria',
  categories_new_category: 'Nuova Categoria',
  categories_remove_category: 'Vuoi davvero rimuovere la Categoria?',
  categories_list_categories: 'Elenco Categorie',
  categories_list_all_categories: 'Tutte le Categorie',
  common_category_sample_name: 'Campione',
  categories_new_category_sample: 'Nuovo Campione',
  categories_remove_category_sample: 'Vuoi davvero rimuovere il Campione?',
  categories_list_categories_samples: 'Elenco Campioni',
  tasting_help: 'Aiuto degustazione',
  common_back: 'Indietro',
  common_next: 'Avanti',
  common_sample_id: 'ID campione',
  common_sample_date: 'Data campione',
  common_duplicate: 'Duplica',
  tasting_raw_materials: 'Materie prime',
  tasting_example_sensory_risk:
    "Esempio principale rischio sensoriale: non conformità all'aroma previsto",
  tasting_procedure: 'Procedura',
  tasting_sample_preparation: 'Preparazione campione',
  tasting_help_comments: 'Commenti',
  common_collection_point: 'Punto raccolta',
  common_collection_date: 'Data raccolta',
  common_brew_number: 'Numero Cotta/MES',
  common_need_explain_nok: 'Non puoi avere campioni NOK senza un commento!',
  common_percent_ok: 'Percentuale OK',
  common_show_all: 'Mostra tutto',
  common_import: 'Importa',
  common_download_template: 'Scarica modello',
  sample_import_message: 'xlsx',
  common_template: 'Modello',
  common_yes: 'Sì',
  common_no: 'No',
  common_only_kpi_sample: 'Solo Campione KPI',
  common_need_volte_first:
    'Non puoi commentare i campioni senza averli prima votati!',
  common_name_template: 'Nome Modello',
  interaction_log: 'Registro interazioni',
  common_message_zone_empty: 'La Zona non può essere vuota.',
  common_message_country_empty: 'Il Paese non può essere vuoto.',
  common_message_site_empty: 'Il Sito non può essere vuoto.',
  user_new_profile_save: 'Nuovo Profilo creato',
  common_in_privileges: 'nei Privilegi',
  common_download_files: 'Scarica file',
  common_create_action: 'Crea azione',
  common_action_list: 'Lista azioni',
  common_create_action_description:
    "Compila i dettagli dell'azione per questo campione.",
  common_optional: 'opzionale',
  action_deadline: 'Scadenza',
  action_description: "Descrizione dell'azione",
  action_description_autofill_tooltip: "Descrizione dell'azione",
  action_description_autofill_tooltip_description:
    'Generato automaticamente (ID round / Birrificio / Nome del campione / Data di produzione / Utente creatore) + descrizione aggiuntiva',
  action_owner: 'Responsabile',
  action_meeting: 'Riunione del registro interazioni',
  action_meeting_list: 'Riunione IAL',
  action_producing_site: 'Sito di produzione',
  action_production_date: 'Data di produzione',
  action_closed_time: 'Ora di chiusura',
  action_meeting_placeholder: 'Seleziona una riunione',
  action_status: 'Stato',
  action_status_draft: 'Bozza',
  action_status_not_started: 'Non avviato',
  action_status_in_progress: 'In corso',
  action_status_delayed: 'In ritardo',
  action_status_close: 'Chiudi',

  action_menu_close: 'Chiudi',
  common_view_details: 'Vedi dettagli',
  action_cancel: 'Annulla',
  action_add_comment: 'Aggiungi commento',
  action_status_canceled: 'Annullato',
  status_record: 'Registro di Stato',
  no_status_record: 'Nessun registro di stato',
  action_type: 'Tipo di azione',
  action_create_user: 'Utente creatore',
  action_create_time: 'Data di creazione',
  action_creator: 'Creatore',
  action_root_cause: 'Causa principale',
  action_description_placeholder: "Inserisci la descrizione dell'azione...",
  action_root_cause_placeholder: 'Inserisci la causa principale...',
  action_comment_added: 'Commento aggiunto con successo',
  action_comment_add_failed: 'Impossibile aggiungere il commento',
  action_comment_placeholder: 'Inserisci il tuo commento...',
  action_status_changed_with_comment: 'Stato cambiato con commento',
  required_comment_banner:
    'Poiché non sei il proprietario di questa azione, è necessario fornire un commento per conto del proprietario.',
  cancel_and_comment: 'Annulla e commenta',
  close_and_comment: 'Chiudi e commenta',
  action_edit_action: 'Modifica azione',
  action_owner_placeholder: 'Seleziona un responsabile',
  action_created_successfully: "L'azione è stata creata con successo!",
  action_created_successfully_desc:
    "Controlla l'azione creata nell'elenco delle azioni.",
  action_updated_successfully: "L'azione è stata aggiornata con successo!",
  action_updated_successfully_desc:
    "Controlla l'azione aggiornata nell'elenco delle azioni.",
  action_create_failed:
    "Si è verificato un problema durante la creazione dell'azione",
  action_update_failed:
    "Si è verificato un problema durante l'aggiornamento dell'azione",
  action_save_failed_desc: 'Riprova tra poco.',
  action_deleted_successfully: "L'azione è stata eliminata con successo!",
  action_deleted_successfully_desc: "Controlla nell'elenco delle azioni.",
  action_delete_failed:
    "Si è verificato un problema durante l'eliminazione dell'azione",
  delete_action_confirm_title: "Eliminare l'azione?",
  delete_action_confirm_description:
    'Questa azione verrà rimossa in modo permanente. Sei sicuro di voler continuare?',
  action_added_notification: '[{{userName}}] ha aggiunto una nuova azione',
  action_updated_notification: '[{{userName}}] ha aggiornato la propria azione',
  action_deleted_notification: '[{{userName}}] ha eliminato la propria azione',
  view_action_list: 'Visualizza Elenco Azioni',
  pdf_viewer: 'Visualizzatore PDF',
  common_all: 'Tutti',
  common_continue: 'Continua',
  common_minimum_score: 'Minimo',
  common_maximum_score: 'Massimo',
  common_average_score: 'Media',
  file_upload_fail:
    'Impossibile caricare il file. Si sono verificati i seguenti errori:',
  file_upload_success_with_error: 'Caricamento completato tranne che per:',
  missing_fields: 'campi mancanti',
  column_error: 'errore colonna',
  common_line: 'Riga',
  file_no_samples: 'Nessun campione trovato nel file!',
  file_success_upload: 'File caricato con successo!',
  file_duplicated_kpi_project: 'KPI o Progetto duplicati',
  round_schedule_maximum_length:
    'La lunghezza massima del nome del turno è di 40 caratteri.',
  sample_malt_varieties: 'Varietà malto',
  error_sample_already_in_round: 'Il campione è già nel turno',
  malt_varieties_has_no_english_name:
    'Devi avere almeno un nome varietà malto.',
  malt_varieties_duplicate:
    'Attenzione: esiste già una varietà malto con questo nome',
  malt_varieties_remove: 'Rimuovi varietà',
  malt_varieties_new: 'Nuova varietà',
  malt_varieties_edit: 'Modifica varietà',
  malt_varieties_enter_name: 'Inserisci il nome',
  malt_varieties_page_description:
    'Gestisci tutte le varietà di malto e le loro configurazioni in un unico luogo.',
  malt_varieties_save_success: 'Varietà di malto creata con successo!',
  malt_varieties_save_success_desc:
    'Controlla nelle varietà di malto qui sotto.',
  malt_varieties_update_success: 'Varietà di malto aggiornata con successo!',
  malt_varieties_update_success_desc:
    'Controlla nelle varietà di malto qui sotto.',
  malt_varieties_delete_title: 'Rimuovere la varietà di malto?',
  malt_varieties_delete_description:
    'La varietà di malto {{name}} verrà rimossa definitivamente. Sei sicuro di voler continuare?',
  malt_varieties_delete_success: 'Varietà di malto eliminata con successo!',
  malt_varieties_delete_success_desc:
    'Controlla nelle varietà di malto qui sotto.',
  malt_varieties_delete_failed:
    'Eliminazione della varietà di malto non riuscita.',
  malt_varieties_delete_failed_desc: 'Riprova tra qualche istante.',
  cancel_new_malt_variety_title: 'Annulla nuova varietà di malto?',
  cancel_edit_malt_variety_title: 'Annulla modifica varietà di malto?',
  cancel_new_malt_variety_confirm: 'Annulla nuova varietà di malto',
  cancel_edit_malt_variety_confirm: 'Annulla modifica varietà di malto',
  reports_no_dates: 'Data inizio e data fine obbligatorie!',
  reports_date_range_message: "L'intervallo date non può superare 1 anno!",
  round_save_select_site: 'Per salvare un turno devi selezionare un sito',
  common_error: 'Oops! Si è verificato un errore. Riprova.',
  common_horizontal: 'Layout orizzontale',
  common_unit: 'Unità',
  common_supplier: 'Fornitore',
  common_flavor: 'Sapore',
  concentration_of_the_base_beer: 'Concentrazione birra base',
  threshold_aml_method: 'Metodo AML (Metodo Limiti Ascendenti)',
  threshold_component_concentration: 'Concentrazione componente',
  threshold_sample_different_help: 'Quale campione è diverso?',
  threshold_each_set_random_order: 'In ogni insieme ordine casuale.',
  threshold_select_base_beer: 'Seleziona Birra Base',
  common_unity: 'Unità',
  common_finish_session: 'Termina sessione',
  common_filters: 'Filtri',
  review_submit_threshold: 'Sei sicuro di voler salvare?',
  threshold_coder_wrong:
    'Il codice inserito è errato. Inserire il codice corretto.',
  threshold_didnt_enter_the_code: 'Inserisci il codice',
  code: 'Codice',
  common_batch_code: 'Codice lotto',
  threshold_samples_required: 'Birra base e sapore sono richiesti',
  threshold_information_helper_sample:
    'Per salvare le informazioni sul campione soglia, clicca sul pulsante Salva',
  code_digits: 'Inserisci il codice di 3 cifre assegnatoti',
  threshold_sample_spiked_with:
    'In ogni set scegliere il campione arricchito con',
  threshold_code_already_tasted:
    'Questo codice è già stato assaggiato da un altro utente. Inserisci un altro codice.',
  common_kpi_brands: 'Marche KPI',
  common_year: 'Anno',
  common_new_kpi_brand: 'Nuova Marca KPI',
  common_action: 'Azione',
  kpi_brand_details_title: 'Dettagli KPI Brand',
  kpi_brand_details_description:
    'Visualizza informazioni complete e lo stato del processo di approvazione.',
  approval_action: 'Azione di Approvazione',
  select_approval_action: "Seleziona un'azione di approvazione",
  reject_reason_title: 'Motivo del Rifiuto',
  reject_reason_description: 'Fornisci un motivo per il rifiuto.',
  reject_reason_label: 'Motivo del rifiuto',
  reject_reason_placeholder: 'Inserisci il motivo del rifiuto...',
  reject_reason_placeholder_site:
    "Inserisci il motivo del rifiuto per questo sito '{{site}}'...",
  common_confirm: 'Conferma',
  common_success: 'Successo',
  common_save_failed: 'Salvataggio fallito. Riprova.',
  approval_status_saved_success: 'Stato di approvazione salvato con successo!',
  common_comment_by_category: 'Commenti per Categoria',
  common_alphabetic_comment: 'Commenti alfabetici',
  common_name_pts_code: 'Codice PTS',
  common_name_pts_code_placeholder: 'Codice',
  common_name_process_item: 'Elemento processo',
  common_name_process_item_placeholder: 'Elemento',
  common_global_brands: 'Marche globali',
  common_global_brand: 'Marca globale',
  common_target_global_brand: 'target per la Marca globale',
  common_focus_brand: 'Marca focus',
  common_target_focus_brand: 'target per la Marca focus',
  common_strategic_brand: 'Marca strategica',
  common_target_strategic_brand: 'target per la Marca strategica',
  common_maximum_sites: 'Il numero massimo di siti da confrontare è',
  common_state_reason_rejecting:
    'Indicare il motivo del rifiuto per questo sito',
  common_rejected_note: 'Nota rifiuto',
  report_list_report_kpi: 'Report KPI',
  report_list_report_taste: 'Report Degustazione',
  select_brand_to_filter: 'Seleziona una Marca globale!',
  select_year_to_filter: 'Seleziona un anno!',
  kpi_only_numbers_warning: 'Accettare solo numeri per i valori Target',
  kpi_max_number_range_warning:
    'Il valore Target deve essere compreso tra 1 e 9',
  kpi_already_selected_brand_warning:
    "Hai già selezionato questa Marca. Selezionane un'altra.",
  kpi_no_kpi_informed_warning:
    'Non è stato inserito alcun valore KPI. Aggiungi il valore.',
  kpi_select_year_warning: 'Seleziona un anno',
  kpi_select_site_warning: 'Seleziona un sito',
  kpi_existing_configuration_warning: 'Hai valori KPI dallo stesso sito e anno',
  kpi_target_empty_warning: 'Un Target di una delle tue Marche è vuoto',
  kpi_saved_successfully: 'I tuoi valori sono stati salvati con successo!',
  kpi_submitted_successfully: 'I tuoi valori sono stati inviati con successo!',
  kpi_max_decimals_warning: 'Il valore Target può avere fino a 3 decimali',
  kpi_count_as_kpi_sample: 'Contare come KPI',
  samples_uncheck_kpi_sample_tooltip:
    'Deseleziona questa casella se non vuoi che questo campione conti nel KPI',
  reports_mandatory_zone_filter: 'Selezionare almeno una zona',
  flavor_unit: 'Unità sapore',
  add_a_sample: 'Aggiungi un campione',
  common_kpi_quarter: 'Trimestre KPI',
  sample_duplicated_quarter_kpi_message:
    'Esiste già un KPI per il trimestre, la marca e il sito che hai selezionato e non potrai salvare.',
  select_quarter: 'Seleziona trimestre',
  please_select_kpi_quarter: 'Selezionare il Trimestre KPI',
  error_fields: `Campi errore`,
  your_answer: 'La tua risposta',
  preference: 'Preferenza',
  please_select_preference_group:
    'È necessario selezionare le preferenze prima di inviare!',
  monthly_report: 'Report mensile',
  draft: 'Bozza',
  confirm_send: 'Conferma e invia',
  sent_completion: 'Invio completato',
  send_draft: 'Invia bozza',
  send_draft_monthly_report: 'Invia il report mensile al tuo indirizzo email.',
  please_confirm_the_recipients: 'Conferma i destinatari del report mensile',
  total_recipients: 'Totale destinatari',
  sending: 'Invio in corso',
  sending_monthly_report_tips1: `La tua richiesta è in elaborazione.`,
  sending_monthly_report_tips2: `Controlla il "Registro azioni" per il risultato.`,
  configure_upgrade_center: 'Configura Centro Aggiornamenti',
  sprint_content: 'Contenuto Sprint',
  release_date: 'Data rilascio',
  add_sprint: 'Aggiungi Sprint',
  sprint_materials: 'Materiali Sprint',
  upgrade_center: 'Centro Aggiornamenti',
  function: 'Funzione',
  my_evaluation_report: 'Il mio rapporto di valutazione',
  upgrade_center_remove_sprint_number:
    'Sei sicuro di voler rimuovere questo numero di Sprint?',
  sprint_version_tips: 'Clicca per visualizzare i materiali dello Sprint.',
  edit_sprint: 'Modifica Sprint',
  new_sprint_tips:
    'Ora puoi cliccare qui per visualizzare i materiali dello sprint.',
  production_date_range: 'Intervallo di date di produzione',
  preparation: 'Preparazione',
  panel: 'Pannello',
  session: 'Sessione',
  product: 'Prodotto',
  attribute: 'Attributo',
  common_menu_samples: 'Campioni',
  common_menu_rounds: 'Giri',
  common_menu_groups: 'Gruppi',
  common_menu_suspension_list: 'Sospensione',
  common_menu_planning_week_sessions: 'Sessioni di pianificazione settimanale',
  common_menu_zitec_sessions: 'Sessioni ZITEC',
  common_menu_brands: 'Marchi',
  common_menu_kpi_brands: 'Marchi KPI',
  common_menu_packages: 'Pacchetti',
  common_menu_styles: 'Stili',
  common_menu_malt_variety: 'Varietà di malto',
  common_menu_intensities: 'Intensità',
  common_menu_categories: 'Categorie',
  common_menu_attributes: 'Attributi',
  common_menu_user_management: 'Gestione utenti',
  common_menu_role_management: 'Gestione ruoli',
  common_menu_permission_control: 'Controllo permessi',
  system: 'Sistema',
  select_taste_type: 'Seleziona tipo di degustatore',
  select_round: 'Seleziona round',
  a_previous_request_is_still_being_processed:
    'Una richiesta precedente è ancora in elaborazione. Riprovare più tardi.',
  select_item: 'Seleziona {{field}}',
  common_new_kpi_brand_button: 'Nuova KPI brand',
  common_target: 'Obiettivo',
  common_focus_brands: 'Marche Focus',
  common_strategic_brands: 'Marche Strategiche',
  kpi_brands_new_page_description:
    'Interfaccia di Creazione Nuova KPI Brand, con funzioni per compilare le informazioni di KPI Brand, inviare e salvare.',
  kpi_brands_edit_page_description:
    'Modifica interfaccia KPI Brand, con funzioni per aggiornare, inviare e salvare informazioni KPI Brand.',
  kpi_brands_edit_page_description_prefix:
    'Visualizza e configura i KPI Brands per ',
  kpi_brands_page_description:
    'Interfaccia di gestione KPI Brands, con funzioni di visualizzazione, invio e revisione.',
  table_apply: 'Applica',
  table_clear: 'Cancella',
  table_search: 'Cerca',
  table_enter_to_filter: 'Inserisci per filtrare...',
  table_select_to_filter: 'Seleziona per filtrare...',
  table_select_all: 'Seleziona tutto',
  table_select_all_aria: 'Seleziona tutte le righe',
  table_select_row_aria: 'Seleziona riga',
  table_filter_by: 'Filtra per',
  table_clear_filters: 'Cancella filtri',
  table_reset_filters: 'Reimposta filtri',
  table_no_results_for_filters: 'Nessun risultato trovato per i filtri applicati.',
  table_items_selected: 'elementi selezionati',
  table_sort: 'Ordina',
  table_sort_toggle: "Clicca per alternare l'ordinamento",
  table_no_options: 'Nessuna opzione disponibile',
  table_reset: 'Ripristina',
  table_all: 'Tutti',
  table_no_results: 'Nessun risultato trovato per i filtri applicati',
  common_approved_at: 'Approvato il {{date}}',
  common_rejected_at: 'Rifiutato il {{date}}',
  kpi_status_created: 'Creato',
  kpi_status_waiting_for_approval: 'In attesa di approvazione',
  kpi_status_approved: 'Approvato',
  kpi_status_rejected: 'Rifiutato',
  kpi_action_approve: 'Approva',
  kpi_action_reject: 'Rifiuta',
  common_by_user: 'da {{user}}',
  pagination_aria_label_next_page: 'Vai alla pagina successiva',
  pagination_aria_label_previous_page: 'Vai alla pagina precedente',
  pagination_aria_label_first_page: 'Vai alla prima pagina',
  pagination_aria_label_last_page: "Vai all'ultima pagina",
  pagination_aria_label_input:
    'Inserisci la pagina desiderata, da 1 a {totalItems}',
  pagination_aria_label_items_per_page:
    '{pageSize} elementi per pagina selezionati, clicca per modificare',
  pagination_lines_per_page: 'Righe per pagina',
  pagination_total_pages: 'di {totalPages}',
  pagination_total_elements: '{firstItem}-{lastItem} di {totalItems} risultati',
  pagination_no_results: 'Nessun risultato trovato',
  kpi_brand_successfully_saved: 'KPI brand salvata con successo!',
  kpi_brand_saved_description:
    'Controllala nella KPI brand qui sotto. Questo è solo un salvataggio temporaneo, la sottomissione per approvazione non è ancora stata completata.',
  kpi_brand_failed_to_save: 'Salvataggio della KPI brand fallito.',
  kpi_brand_save_failed_description: 'Riprova tra un momento.',
  kpi_brand_successfully_submitted: 'KPI brand creata con successo!',
  kpi_brand_submitted_description:
    "Controlla la KPI brand qui sotto. Verifica lo stato di approvazione nella pagina di dettaglio; questa KPI brand sarà disponibile solo dopo l'approvazione.",
  kpi_brand_failed_to_submit: 'Creazione della KPI brand fallita.',
  kpi_brand_submit_failed_description: 'Riprova tra un momento.',
  flavor_id_discussion: "Discussione sull'identificazione dei sapori",
  view_and_discussion_for: 'Visualizza e discuti per',
  common_cup: 'Tazza',
  tasters_joined: 'Degustatori partecipanti',
  tasters_all_correct: 'Degustatori tutto corretto',
  total_accuracy: 'Precisione totale',
  accuracy: 'Precisione',
  all_correct: 'Tutto corretto',
  otherwise: 'Altri',
  result: 'Risultato',
  Key: 'Key',
  nonkey: 'Nonkey',
  common_guest: 'Ospite',
  view_correct_answers: 'Visualizza risposte corrette',
  hide_correct_answers: 'Nascondi risposte corrette',
  change_to_table: 'Passa alla tabella',
  change_to_card: 'Passa alle schede',
  not_answered: 'Non risposto',
  countdown: 'Conto alla rovescia',
  check_the_answer_at_the_end_of_the_countdown:
    'Si prega di attendere che il conto alla rovescia arrivi a zero per controllare il risultato.',
  sensory_intelligent_platform: 'Piattaforma Intelligente Sensory - PBI',
  actions: 'Azioni',
  actions_page_description:
    'Visualizza tutte le Azioni create dagli utenti durante la sessione di degustazione.',
  action_created_by: 'Creato da',
  my_actions: 'Le mie Azioni',
  action_list_info: "L'azione verrà creata dopo la chiusura del round.",
  unsaved_changes_warning:
    'Sono presenti modifiche non salvate. Vuoi davvero uscire?',
  common_go_back: 'Indietro',
  cancel_create_action_title: "Annullare la creazione dell'azione?",
  cancel_edit_action_title: "Annullare la modifica dell'azione?",
  cancel_create_action_confirm: "Annulla la creazione dell'azione",
  cancel_edit_action_confirm: "Annulla la modifica dell'azione",
  unsaved_changes_description:
    'Hai inserito dei contenuti nel modulo. Annullando perderai tutti i dati non salvati. Vuoi continuare?',
  unsaved_changes_edit_description:
    'Hai modificato il contenuto del modulo. Annullando perderai tutte le modifiche non salvate. Vuoi continuare?',
  action_update_failed_desc: 'Riprova tra poco.',
  action_change_status_successfully: 'Stato modificato!',
  action_change_status_successfully_desc:
    "Lo stato dell'azione è stato modificato in {{status}}.",
  action_change_status_failed: 'Impossibile modificare lo stato',
  action_change_status_failed_desc:
    "Impossibile modificare lo stato dell'azione. Riprova.",
  download_report_success: 'Report scaricati correttamente!',
  download_report_success_desc: 'Puoi trovarli nella cartella Download.',
  download_self_evaluation_report_success:
    'Report di autovalutazione scaricato correttamente!',
  download_report_failed: 'Impossibile scaricare i report.',
  download_report_failed_desc: 'Riprova tra poco.',
  evaluation_report_add_success: 'Report aggiunto correttamente!',
  evaluation_report_add_success_desc:
    "Consultalo nel report di valutazione 'Da scaricare'.",
  evaluation_report_add_failed: 'Impossibile aggiungere il report.',
  evaluation_report_add_failed_desc: 'Riprova tra poco.',
  configure_table_title: 'Personalizza colonne',
  configure_table: 'Configura tabella',
  configure_table_description:
    'Scegli le colonne visibili e modifica il loro ordine.',
  configure_table_helper:
    'Devono essere visibili almeno 2 colonne e si possono fissare al massimo 4 colonne.',
  configure_table_fixed_left: 'Fissata a sinistra',
  configure_table_scroll_area: 'Area di scorrimento',
  configure_table_fixed_right: 'Fissata a destra',
  configure_table_empty_left:
    'Trascina qui una colonna per fissarla a sinistra',
  configure_table_empty_right: 'Trascina qui una colonna per fissarla a destra',
  configure_table_save: 'Salva modifiche',
  configure_table_reset: 'Ripristina impostazioni predefinite',
  configure_table_discard: 'Ignora modifiche',
  configure_table_show: 'Mostra',
  configure_table_hide: 'Nascondi',
  configure_table_min_visible: 'Devono rimanere visibili almeno 2 colonne',
  configure_table_max_fixed: 'Puoi fissare al massimo 4 colonne',
  configure_table_drag: 'Trascina per riordinare',
  configure_table_dragging: 'Trascinamento',
  add_taster: 'Aggiungi degustatore',
  alcohol_concentration_configuration: 'Configurazione della concentrazione di alcol',
  breathalyzer_configuration_description:
    'Configura la concentrazione di alcol per ogni sito e lo stato di guida degli utenti.',
  breathalyzer_configuration_save_success_title: 'Configurazione dell’alcolimetro aggiornata correttamente!',
  breathalyzer_configuration_save_success_description: 'Controlla le configurazioni aggiornate nelle impostazioni qui sotto.',
  breathalyzer_configuration_save_failed_title: 'Si è verificato un problema durante l’aggiornamento della configurazione dell’alcolimetro',
  breathalyzer_configuration_save_failed_description: 'Riprova tra poco.',
  cancel_configuration_title: 'Annullare la configurazione?',
  cancel_configuration_description: 'Hai apportato modifiche alla configurazione. Annullando perderai le modifiche non salvate. Vuoi continuare?',
  cancel_configuration_confirm: 'Annulla configurazione',
  driving_configuration: 'Configurazione della guida',
  breathalyzer_page_description:
    'Gestisci tutti i risultati dell’alcoltest e i relativi standard di configurazione in un unico posto.',
  breathalyzer_connection_failed_title:
    'Connessione all’alcoltest non riuscita',
  breathalyzer_connection_failed_desc: 'Aggiorna la pagina e riprova.',
  alcohol_result_submit_failed_title:
    'Si è verificato un problema durante l’invio del risultato',
  alcohol_result_submit_failed_desc: 'Riprova tra poco.',
  auto: 'Automatico',
  alcohol_concentration_result: 'Risultato della concentrazione di alcol',
  absence_save_success: 'Motivo dell’assenza aggiunto correttamente!',
  absence_save_success_desc: 'Verificalo nelle assenze inviate.',
  submitted_absence: 'Assenze inviate',
  no_absence_to_show: 'Nessuna assenza da mostrare',
  absence_delete_success: 'Motivo dell’assenza eliminato correttamente!',
  absence_delete_success_desc: 'Controlla l’elenco aggiornato nelle assenze inviate.',
  absence_delete_confirm_title: 'Eliminare l’assenza?',
  absence_delete_confirm_description: 'L’assenza [{{start}} - {{finish}}] verrà eliminata definitivamente. Vuoi continuare?',
  absence_delete_confirm_delete: 'Elimina',
  absence_save_failed: 'Impossibile aggiungere il motivo dell’assenza',
  absence_save_failed_desc: 'Riprova tra poco.',
  absence_duplicate_date_desc:
    'Esiste già un record di assenza per la data selezionata. Non sono consentiti invii duplicati.',
  absence_delete_failed: 'Impossibile eliminare il motivo dell’assenza',
  absence_delete_failed_desc: 'Riprova tra poco.',
  role_management_change_role: 'Cambia ruolo',
  role_management_reset_success: 'Autorizzazioni reimpostate correttamente!',
  role_management_reset_success_desc: 'Le autorizzazioni di questo ruolo sono state reimpostate alla configurazione predefinita.',
  role_management_reset_failed: 'Impossibile reimpostare le autorizzazioni.',
  role_management_reset_failed_desc: 'Riprova tra poco.',
  role_management_switch_role_title: 'Ignorare le modifiche?',
  role_management_switch_role_description: 'Sono presenti modifiche alle autorizzazioni non salvate. Cambiando ruolo verranno ignorate. Vuoi continuare?',
  role_management_switch_role_confirm: 'Cambia ruolo',
  role_management_created: 'Ruolo personalizzato creato correttamente!',
  role_management_created_desc: 'Verificalo nel controllo delle autorizzazioni qui sotto.',
  role_management_permissions_failed: 'Impossibile caricare le autorizzazioni.',
  role_management_create_failed: 'Impossibile creare il ruolo.',
  role_management_create_required: 'Inserisci un nome ruolo e seleziona un set di autorizzazioni.',
  role_management_create_failed_desc: 'Riprova tra poco.',
  role_management_save_success: 'Autorizzazioni del ruolo aggiornate correttamente!',
  role_management_save_success_desc: 'Le modifiche sono state salvate. Puoi verificarle nel controllo delle autorizzazioni qui sotto.',
  role_management_save_failed: 'Impossibile salvare le modifiche del ruolo.',
  role_management_save_failed_desc: 'Riprova tra poco.',
  role_management_permission: 'Funzione',
  role_management_view: 'Visualizza',
  role_management_edit: 'Modifica',
  role_management_approve: 'Approva',
  role_management_search: 'Cerca ruoli',
  role_management_current_role_prefix: 'Il tuo ruolo attuale è',
  role_management_create: 'Crea ruolo personalizzato',
  role_management_save_changes: 'Salva modifiche',
  common_apply: 'Applica',
  role_management_reset_title: 'Reimpostare le autorizzazioni predefinite?',
  role_management_reset_description: 'Le autorizzazioni del ruolo verranno reimpostate alla configurazione predefinita e tutte le modifiche manuali verranno rimosse. Questa azione non può essere annullata.',
  cancel_create_role_title: 'Annullare la creazione del ruolo personalizzato?',
  cancel_create_role_confirm: 'Annulla creazione ruolo',
  cancel_create_role_description: 'Hai inserito dei dati nel modulo. Annullando, tutti i dati non salvati verranno eliminati. Vuoi continuare?',
  role_management_delete_title: 'Eliminare il ruolo personalizzato?',
  role_management_default_role: 'il ruolo predefinito',
  Search: 'Cerca',
  reset: 'Reimposta',
  role_management_delete_preview_no_users: 'Il ruolo personalizzato «{{role}}» verrà rimosso definitivamente. Vuoi continuare?',
  role_management_create_title: 'Crea ruolo personalizzato',
  role_management_role_name: 'Nome ruolo',
  role_management_permission_set: 'Set di autorizzazioni da personalizzare',
  role_management_role_name_placeholder: 'Inserisci il nome del ruolo',
  role_management_permission_set_placeholder: 'Seleziona un set di autorizzazioni',
  role_management_reset_success: 'Autorizzazioni reimpostate correttamente!',
  role_management_reset_success_desc: 'Le autorizzazioni di questo ruolo sono state reimpostate alla configurazione predefinita.',
  role_management_reset_failed: 'Impossibile reimpostare le autorizzazioni.',
  role_management_reset_failed_desc: 'Riprova tra poco.',
};
